import React, { Component } from "react";
import { ToastContainer, toast } from "react-toastify";
import Httpconfig from "../helpers/HttpconfigAdmin";
import Constant from "../../constants";
import { I18nPropvider } from "../../i18nProvider";
import Patnewcss from "../../public/css/doctor/doctor.css";
import PatientFooter from "../patient/Patientfooter";
import { reactLocalStorage } from "reactjs-localstorage";
import {
  ROLE_OPERATIONS,
  OPERATIONS_LANDING,
  getAdminRole,
  getAdminUser,
} from "../../helpers/adminRoles";
const moment = require("moment");

export default class Operationslogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {},
      errors: {},
      type: "password",
      img: "../images/doctor-img/Login screens/hide_icon.svg",
    };
    this.showPassword = this.showPassword.bind(this);
  }

  //  For handleChange
  handleChange = (field, event) => {
    let fields = this.state.fields;
    fields[field] = event.target.value;
    this.setState({ fields });
  };

  //  For submitting the form
  checkSubmit(event) {
    event.preventDefault();
    if (this.handleValidation()) {
      this.checkLogin(event);
    } else {
      toast.warn("Form has errors.");
    }
  }

  //  For validating the fields
  handleValidation() {
    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;

    if (!fields["username"]) {
      formIsValid = false;
      errors["username"] = "User name cannot be empty";
    } else if (
      typeof fields["username"] !== "undefined" &&
      fields["username"].lastIndexOf("@") > 0
    ) {
      let lastAtPos = fields["username"].lastIndexOf("@");
      let lastDotPos = fields["username"].lastIndexOf(".");
      if (
        !(
          lastAtPos < lastDotPos &&
          lastAtPos > 0 &&
          fields["username"].indexOf("@@") == -1 &&
          lastDotPos > 2 &&
          fields["username"].length - lastDotPos > 2
        )
      ) {
        formIsValid = false;
        errors["username"] = "Email is invalid";
      }
    } else if (!/^[0-9]+$/g.exec(fields["username"])) {
      formIsValid = false;
      errors["username"] = "Invalid Username / Special characters not allowed";
    } else if (fields["username"].length < 10) {
      formIsValid = false;
      errors["username"] = "Phone number invalid";
    } else {
      errors["username"] = "";
    }
    if (!fields["pwd"]) {
      formIsValid = false;
      errors["pwd"] = "password cannot be empty";
    } else {
      errors["pwd"] = "";
    }

    this.setState({ errors: errors });
    return formIsValid;
  }

  //  For checking login
  checkLogin = (event) => {
    event.preventDefault();
    const { fields } = this.state;
    if (fields["username"].lastIndexOf("@") > 0) {
      var post_data = {
        email: fields["username"],
        role: ROLE_OPERATIONS,
        password: fields["pwd"],
        timezone: moment.tz.guess(),
      };
    } else {
      var post_data = {
        phone: fields["username"],
        role: ROLE_OPERATIONS,
        password: fields["pwd"],
        timezone: moment.tz.guess(),
      };
    }

    Httpconfig.httptokenpost(Constant.siteurl + "api/Users/login", post_data)
      .then((response) => {
        if (response.data.status == 200 && response.data.error) {
          toast.error(response.data.message);
          return;
        }
        if (
          response.data.loginOutput.notification.code == 200 &&
          response.data.loginOutput.notification.type == "Success"
        ) {
          const userobj = response.data.loginOutput.data.userobj;
          //  Operations drives the same admin screens, so it reuses the admin
          //  session keys. user_type is what restricts what it can see.
          if (userobj.user_type !== ROLE_OPERATIONS) {
            toast.error("This login is for operations users only.");
            return;
          }
          reactLocalStorage.setObject("AdminUserObj", userobj);
          localStorage.setItem("AdminToken", userobj.accessToken);
          toast.success(response.data.loginOutput.notification.message);
          setTimeout(() => this.props.history.push(OPERATIONS_LANDING), 2000);
        } else if (
          response.data.loginOutput.notification.code == 200 &&
          response.data.loginOutput.notification.type == "Failure"
        ) {
          toast.error(response.data.message);
          return;
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  //  Get the values after the first render
  componentDidMount = () => {
    if (getAdminUser() != null && getAdminRole() === ROLE_OPERATIONS) {
      setTimeout(() => this.props.history.push(OPERATIONS_LANDING), 2000);
    }
  };

  //  For showing the password
  showPassword() {
    if (this.state.type == "input") {
      this.setState({
        type: "password",
        img: "../images/doctor-img/Login screens/hide_icon.svg",
      });
    } else {
      this.setState({
        type: "input",
        img: "../images/doctor-img/Login screens/unhide_icon.svg",
      });
    }
  }

  render() {
    return (
      <main id="main">
        <I18nPropvider locale={this.state.Language}>
          <section id="doctor_login">
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-6 doc_img_mid">
                  <div class="doc_login_img">
                    <img src="../../images/patient/img/main-logo.png" />
                  </div>
                </div>
                <div class="col-md-6 doc_form_mid">
                  <div class="doc_login_form">
                    <h2>Login to Operations</h2>
                    <form onSubmit={this.checkSubmit.bind(this)}>
                      <div class="form-group">
                        <label>Mobile or Email</label>
                        <input
                          type="text"
                          class="form-control log_input"
                          name="username"
                          id="username"
                          placeholder="Mobile or Email"
                          onChange={this.handleChange.bind(this, "username")}
                        />
                      </div>
                      <span className="cRed">
                        {this.state.errors["username"]}
                      </span>
                      <div class="form-group">
                        <label>Password</label>
                        <div class="pw-div">
                          <input
                            type={this.state.type}
                            class="form-control log_input"
                            name="pwd"
                            id="pwd"
                            placeholder="Password"
                            onChange={this.handleChange.bind(this, "pwd")}
                          />
                          <img
                            class="password_ico"
                            onClick={this.showPassword}
                            src={this.state.img}
                          />
                        </div>
                      </div>
                      <span className="cRed">{this.state.errors["pwd"]}</span>

                      <button type="submit" class="btn btn-default doc_log_btn">
                        Login
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <ToastContainer />
        </I18nPropvider>
        <PatientFooter />
      </main>
    );
  }
}
